export const siteMeta = {
  name: "黑瓜吃料",
  slogan: "蹲守第一现场 · 新瓜抢先吃",
  intro:
    "黑瓜吃料是一个专注于娱乐现场蹲点的吃瓜资讯站，全天候跟进明星动态、综艺爆料、影视内幕与音乐现场，把散落的时间线整理成一条能看懂的脉络。",
  email: "contact@heiguachiliao.com",
};

export const navLinks = [
  { label: "今日热瓜", href: "#hot" },
  { label: "瓜料分类", href: "#categories" },
  { label: "最新爆料", href: "#feed" },
  { label: "蹲点日历", href: "#timeline" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export const heroTicker = [
  "深夜路透流出，剧组取景地成讨论焦点",
  "综艺录制临时改流程，现场观众晒出场顺序",
  "巡演收官站加座三成，票务凌晨一度排队",
  "联名单品补货消息传出，二手价格回落",
  "音乐节阵容官宣，压轴嘉宾留白",
  "短剧单集数据刷新，同款取景地被打卡",
];

export const siteStats = [
  { value: "24 小时", label: "蹲点更新" },
  { value: "3.2 万+", label: "累计瓜料" },
  { value: "18 万", label: "网友关注" },
  { value: "6 大", label: "瓜料分类" },
];

export const hotGossips = [
  {
    id: "hot-1",
    title: "顶流剧组深夜加戏路透流出，网友顺着时间线扒出档期线索",
    excerpt:
      "一段模糊的深夜路透在凌晨流传，画面里的场地与剧组官宣的取景地并不一致。网友把通告单、路透与官宣节点摆在一起对比，越看越觉得耐人寻味。",
    category: "影视内幕",
    time: "12 分钟前",
    reads: "8.6 万",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20newsroom%20desk%20with%20scattered%20newspapers%2C%20vintage%20film%20camera%20and%20glowing%20warm%20desk%20lamp%2C%20deep%20crimson%20and%20amber%20cinematic%20lighting%2C%20moody%20editorial%20atmosphere%2C%20textured%20composition%2C%20no%20people&width=1200&height=800&seq=heigua-feature-01&orientation=landscape",
  },
  {
    id: "hot-2",
    title: "综艺录制现场临时改流程，嘉宾站位调整引发连番猜测",
    excerpt:
      "现场观众晒出新的出场顺序，与开录前公布的版本存在出入，节目组暂未说明调整原因。",
    category: "综艺爆料",
    time: "28 分钟前",
    reads: "5.2 万",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20glowing%20vintage%20microphone%20on%20a%20dark%20stage%20with%20warm%20amber%20rim%20light%20and%20bokeh%20spotlights%2C%20moody%20entertainment%20news%20mood%2C%20cinematic%20depth%20of%20field%2C%20textured%20dark%20background%2C%20no%20people&width=800&height=600&seq=heigua-gua-01&orientation=landscape",
  },
  {
    id: "hot-3",
    title: "巡演收官站加座三成仍秒空，票务系统凌晨一度拥堵",
    excerpt:
      "主办方公布加座消息后，开票仅十余分钟即显示售罄，二手平台的溢价讨论随之升温。",
    category: "音乐现场",
    time: "1 小时前",
    reads: "4.7 万",
    image:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20silhouette%20with%20dramatic%20warm%20spotlight%20beams%20cutting%20through%20fog%2C%20empty%20arena%20seating%20in%20the%20dark%2C%20vivid%20amber%20and%20crimson%20tones%2C%20cinematic%20wide%20composition%2C%20no%20people&width=800&height=600&seq=heigua-gua-03&orientation=landscape",
  },
  {
    id: "hot-4",
    title: "新剧开机造型路透刷屏，两派网友为定妆风格吵上热搜",
    excerpt:
      "定妆路透一出，关于服化道是否贴合角色设定的讨论迅速发酵，双方各有依据。",
    category: "影视内幕",
    time: "2 小时前",
    reads: "3.9 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20film%20set%20with%20camera%20rig%2C%20softboxes%20and%20folding%20director%20chair%20under%20warm%20low%20light%2C%20moody%20crimson%20and%20gold%20color%20grading%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20people&width=800&height=600&seq=heigua-gua-04&orientation=landscape",
  },
];

export const categories = [
  { id: "star", name: "明星动态", icon: "ri-user-star-line", count: 128, desc: "账号动态、行程变化与社媒细节" },
  { id: "variety", name: "综艺爆料", icon: "ri-mic-line", count: 96, desc: "录制现场、嘉宾阵容与流程调整" },
  { id: "film", name: "影视内幕", icon: "ri-film-line", count: 143, desc: "开机路透、定妆造型与剪辑变动" },
  { id: "music", name: "音乐现场", icon: "ri-music-2-line", count: 87, desc: "巡演、音乐节与livehouse现场" },
  { id: "creator", name: "网红圈", icon: "ri-live-line", count: 74, desc: "短剧、直播与内容创作者的动向" },
  { id: "fashion", name: "时尚潮流", icon: "ri-t-shirt-line", count: 59, desc: "秀场、联名与单品发售情报" },
];

export const feedItems = [
  {
    id: "feed-1",
    title: "某音乐综艺中段更换合作舞台，知情人称与档期有关",
    excerpt:
      "原本排在第二轮的合作舞台被后移，彩排顺序也做了调整，节目组只回应以播出为准。",
    category: "综艺爆料",
    tag: "现场",
    time: "35 分钟前",
    reads: "3.4 万",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20glowing%20vintage%20microphone%20on%20a%20dark%20stage%20with%20warm%20amber%20rim%20light%20and%20bokeh%20spotlights%2C%20moody%20entertainment%20news%20mood%2C%20cinematic%20depth%20of%20field%2C%20textured%20dark%20background%2C%20no%20people&width=800&height=600&seq=heigua-gua-01&orientation=landscape",
  },
  {
    id: "feed-2",
    title: "巡演城市站官宣加开一场，主办方回应座位安排质疑",
    excerpt: "针对看台视线遮挡的反馈，主办方表示将开放部分区域的退换通道。",
    category: "音乐现场",
    tag: "巡演",
    time: "1 小时前",
    reads: "2.9 万",
    image:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20silhouette%20with%20dramatic%20warm%20spotlight%20beams%20cutting%20through%20fog%2C%20empty%20arena%20seating%20in%20the%20dark%2C%20vivid%20amber%20and%20crimson%20tones%2C%20cinematic%20wide%20composition%2C%20no%20people&width=800&height=600&seq=heigua-gua-03&orientation=landscape",
  },
  {
    id: "feed-3",
    title: "新剧杀青特辑上线，删减片段花絮意外成为讨论焦点",
    excerpt: "特辑里几秒钟的过场镜头，被网友截出来对照原著情节，讨论度反超正片。",
    category: "影视内幕",
    tag: "路透",
    time: "2 小时前",
    reads: "4.1 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20film%20set%20with%20camera%20rig%2C%20softboxes%20and%20folding%20director%20chair%20under%20warm%20low%20light%2C%20moody%20crimson%20and%20gold%20color%20grading%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20people&width=800&height=600&seq=heigua-gua-04&orientation=landscape",
  },
  {
    id: "feed-4",
    title: "联名款单品上线十分钟售罄，二手平台价格翻倍引热议",
    excerpt: "补货时间尚未公布，官方客服建议关注后续公告，避免在非官方渠道下单。",
    category: "时尚潮流",
    tag: "联名",
    time: "3 小时前",
    reads: "2.6 万",
    image:
      "https://readdy.ai/api/search-image?query=Fashion%20week%20runway%20lights%20abstract%20with%20glossy%20floor%20reflections%20in%20warm%20gold%20and%20deep%20red%2C%20blurred%20audience%20silhouettes%2C%20cinematic%20elegant%20mood%2C%20high%20contrast%2C%20no%20faces&width=800&height=600&seq=heigua-gua-05&orientation=landscape",
  },
  {
    id: "feed-5",
    title: "短视频短剧再出黑马，单集播放破亿带动同款取景地",
    excerpt: "取景地所在的老街周末人流翻倍，当地商户说没想到会被一部短剧带火。",
    category: "网红圈",
    tag: "短剧",
    time: "4 小时前",
    reads: "5.8 万",
    image:
      "https://readdy.ai/api/search-image?query=Night%20music%20festival%20crowd%20glow%20with%20warm%20stage%20lights%20and%20confetti%20in%20the%20air%2C%20abstract%20blurred%20motion%2C%20rich%20amber%20and%20red%20tones%2C%20cinematic%20atmosphere%2C%20no%20distinct%20faces&width=800&height=600&seq=heigua-gua-06&orientation=landscape",
  },
  {
    id: "feed-6",
    title: "音乐节阵容官宣，压轴嘉宾身份留白成最大悬念",
    excerpt: "官方海报把压轴位置做成剪影，网友依演出时长与档期开始一轮新推演。",
    category: "音乐现场",
    tag: "阵容",
    time: "5 小时前",
    reads: "3.7 万",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20backstage%20corridor%20with%20scattered%20warm%20lamps%2C%20hanging%20cables%20and%20a%20clapperboard%20silhouette%20on%20a%20table%2C%20cinematic%20amber%20and%20red%20tones%2C%20blurred%20dramatic%20lighting%2C%20editorial%20vibe%2C%20no%20people&width=800&height=600&seq=heigua-gua-02&orientation=landscape",
  },
  {
    id: "feed-7",
    title: "演员社交账号凌晨更动态，粉丝逐字解读引连锁猜想",
    excerpt: "一条配图不加文案的动态在凌晨发出，评论区很快堆起各种版本的解读。",
    category: "明星动态",
    tag: "动态",
    time: "7 小时前",
    reads: "6.2 万",
    image:
      "https://readdy.ai/api/search-image?query=Fashion%20week%20runway%20lights%20abstract%20with%20glossy%20floor%20reflections%20in%20warm%20gold%20and%20deep%20red%2C%20blurred%20audience%20silhouettes%2C%20cinematic%20elegant%20mood%2C%20high%20contrast%2C%20no%20faces&width=800&height=600&seq=heigua-gua-05&orientation=landscape",
  },
  {
    id: "feed-8",
    title: "时尚周闭幕秀邀请名单流出，新人面孔占比明显提升",
    excerpt: "名单里出现了不少近一年才冒头的新面孔，品牌方的选人思路引发讨论。",
    category: "时尚潮流",
    tag: "秀场",
    time: "9 小时前",
    reads: "2.1 万",
    image:
      "https://readdy.ai/api/search-image?query=Night%20music%20festival%20crowd%20glow%20with%20warm%20stage%20lights%20and%20confetti%20in%20the%20air%2C%20abstract%20blurred%20motion%2C%20rich%20amber%20and%20red%20tones%2C%20cinematic%20atmosphere%2C%20no%20distinct%20faces&width=800&height=600&seq=heigua-gua-06&orientation=landscape",
  },
];

export const timelineEvents = [
  { date: "09-12", time: "23:40", title: "深夜路透流出，剧组取景地成讨论焦点", category: "影视内幕" },
  { date: "09-12", time: "21:15", title: "综艺录制现场流程调整，观众晒出场顺序", category: "综艺爆料" },
  { date: "09-12", time: "18:30", title: "巡演加座公告发布，票务平台一度排队", category: "音乐现场" },
  { date: "09-12", time: "15:05", title: "联名单品补货消息传出，粉丝整理抢购攻略", category: "时尚潮流" },
  { date: "09-12", time: "11:20", title: "短剧单集数据刷新，制作方低调回应", category: "网红圈" },
  { date: "09-11", time: "22:48", title: "演员深夜发文后删除，截图在各平台流传", category: "明星动态" },
];

export const testimonials = [
  {
    name: "瓜田里的猹",
    tag: "蹲点两年",
    text: "更新是真的快。别的号还在搬运旧图的时候，这里已经把时间线按顺序整理好了，省心。",
  },
  {
    name: "晚八点准时到",
    tag: "综艺党",
    text: "最爱蹲点日历，几点发生了什么一目了然，不用在评论区翻半天找线索。",
  },
  {
    name: "柠檬不太酸",
    tag: "音乐现场",
    text: "巡演和音乐节的消息挺全，加座和阵容调整基本都能第一时间看到，买票心里有底。",
  },
  {
    name: "只吃真瓜",
    tag: "理性吃瓜",
    text: "会标出待核实和来源的部分，不会一上来就下结论，这种克制的写法在吃瓜站里很难得。",
  },
];

export const faqs = [
  {
    q: "黑瓜吃料的瓜料来源可靠吗？",
    a: "我们把内容分为「已确认」与「待核实」两类，并在正文中标注信息来源类型。来自官方公告或节目播出画面的内容会标注为已确认，来自路透、现场观众反馈的内容会标注为待核实，方便你自行判断。",
  },
  {
    q: "网站多久更新一次？",
    a: "蹲点日历一般按当天实时更新，出现热门事件时会加密更新频次。最新爆料板块按发布时间倒序排列，你打开页面看到的第一条通常就是刚刚整理好的内容。",
  },
  {
    q: "可以投稿自己的瓜料吗？",
    a: "可以。页面底部的「爆料投稿」表单支持提交线索，建议写清事件发生的时间、地点与你能提供的佐证类型，编辑看到后会尽快跟进核实。",
  },
  {
    q: "你们会核实后再发布吗？",
    a: "会做基础核实，但娱乐事件本身存在大量不确定信息。对于暂时无法确认的细节，我们会在正文里明确写出「待核实」，不会用肯定语气描述未经证实的传闻。",
  },
  {
    q: "怎样第一时间看到新瓜？",
    a: "把本站加入浏览器收藏并置顶，或者关注首页的实时快讯条，热点一旦有进展都会在这里滚动出现。蹲点日历则适合回头查当天完整脉络。",
  },
  {
    q: "浏览内容需要付费吗？",
    a: "不需要。黑瓜吃料的所有资讯内容都免费开放浏览，也没有会员墙或付费解锁的板块。",
  },
];